<li
  class="cursor-pointer hover:bg-chathams-blue-400 b rounded p-2"
  routerLinkActive="bg-cerise-red"
  style="min-width: 7rem"
>
  <a class="flex items-center justify-center gap-2 h-8" [routerLink]="'/dash/' + route">
    <div class="flex justify-center min-w-max">
      <img [src]="'./assets/icons/' + icon + '.svg'" [alt]="label" class="w-4 h-4" />
    </div>
    <div class="text-sm text-white font-medium whitespace-nowrap">
      {{ label }}
    </div>
    <div *ngIf="hasNotification" class="w-2 h-2 rounded bg-status-warning mr-2"></div>
  </a>
</li>
